import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SpinnerService } from './core/services/spinner.service';
import { LanguageService } from './core/services/language.service';
import { SvgInlineDirective } from './shared/directives/svg/svg-inline.directive';
import { GlobalSpinnerService } from './core/services/global-spinner.service';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet,
    TranslateModule,
    SvgInlineDirective,
    CommonModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Tallam.StudentsUI';
  loading$ = this.spinnerService.loading$;
  private isBrowser: boolean;
  constructor(private spinnerService: SpinnerService,
    private translate: TranslateService,
    @Inject(PLATFORM_ID) private platformId: Object,
  private languageService: LanguageService,
private globalSpinnerService: GlobalSpinnerService) {
      this.isBrowser = isPlatformBrowser(this.platformId);
    this.translate.addLangs(['en-US', 'ar-SA']);
    this.translate.setDefaultLang('ar-SA');
      // ✅ Set translation language based on current language (from LanguageService)
    if (this.isBrowser) {
      const lang = this.languageService.getLanguage();
      const translateLang = lang === 'ar' ? 'ar-SA' : 'en-US';
      this.languageService.applyLanguageSettings(lang);
      // this.translate.use(translateLang);
       this.translate.use(translateLang).subscribe({
    next: () => console.log('✅ لغة الترجمة تم تحميلها:', translateLang),
    error: (err) => console.error('❌ فشل تحميل ملف الترجمة:', err)
  });
    }
  }
  ngOnInit(): void {
    if (this.isBrowser) {
      this.globalSpinnerService.init();
    }
  }

  
}
